import { Link } from "react-router-dom";

export default function Footer () {
    return (
        <div class="b-two p-6">
        <div class="dtwo">Extra Links</div>
        <div class="my-4">
            <ul class="list-disc">
                <li class="underline">
                <Link class="" to="/comparison">Idea and Traditional Resume</Link>
                </li>
            </ul>
        </div>
        <div class="dtwo">A number venture</div>
        <div class="my-4">
            <ul class="list-disc">
                <li class="">
                <Link class="" to="/pricing">Pricing</Link>
                </li>
                <li class="">
                <Link class="" to="/vision">Vision</Link>
                </li>
                <li class="">
                <Link class="" to="">Roadmap</Link>
                </li>
                <li class="">
                <Link class="" to="/ambassador">Campus Ambassador Program</Link>
                </li>
                <li class="">
                <Link class="" to="">Privacy Policy</Link>
                </li>
            </ul>
        </div>
        <div>Launching in Aug, 2023</div>
        <div class="h-20"></div>
        </div>
    );
}